export default __webpack_public_path__ + "static/media/emergency-power-supply-rooms-v4.064c4042.jpg";